/**
 * COOKIE-BYTE.JS
 */

 import {CookieConsent, CookieCovers, CookieModal} from '../../../vendor/ddm-studio/cookie-byte';

 export default function InitCookieByte() {
	 window.CookieConsent = new CookieConsent({
		 autorun: false,
	 });
	 window.CookieModal = new CookieModal(window.CookieConsent);
	 window.CookieCovers = new CookieCovers(window.CookieConsent);
 
	 window.CookieConsent.registerCallback('third-party', function () {
		 const iframeWrappers = document.querySelectorAll('.bard__module.iframe .iframe-wrapper');
 
		 iframeWrappers.forEach((iframeWrapper) => {
			 if (iframeWrapper !== undefined) {
				 var scriptTag = iframeWrapper.querySelector('script[type="text/htmlsnippet"]');
				 if (scriptTag === null) return;
 
				 var htmlNode = document.createElement('div');
				 htmlNode.innerHTML = scriptTag.text.trim();
				 iframeWrapper.prepend(htmlNode.firstChild);
			 }
		 });
	 });
 
	 window.CookieConsent.runCallbacks();
 }